import { Box, Divider, Grid } from '@mui/material';
import { toTitleCase } from 'common/utils';
import CaseInfoItem from 'components/case/CaseInfoItem/CaseInfoItem';
import CustomText from 'components/common/CustomText/CustomText';
import React, { useMemo } from 'react'
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';

interface Props {
  data: any;
}

export default function PatientInformationDetails({ data }: Props) {
  const globalStyles = useGlobalStyles();

  const patientName = useMemo(() => {
    return data ? `${data?.patient_last_name}, ${data?.patient_first_name}` : '';
  }, [data]);

  const fields = [
    { label: 'Patient Name', value: patientName },
    { label: 'Gender', value: toTitleCase(data.gender) },
    { label: 'Date of Birth', value: data.date_of_birth },
    { label: 'Age', value: data.age },
    { label: 'Medical Record Number', value: data.mrn },
    { label: 'Race', value: data.race },
    { label: 'Insurance', value: data.insurance },
    { label: 'Insurance Status', value: data.insurance_status },
    { label: 'Institution', value: data.hospital.address },
    { label: 'Primary Surgeon(s)', value: data.primary_surgeons?.map((item: any) => `(${item})`).join(', ') },
    { label: 'Co-Surgeon(s)', value: data.co_surgeons?.map((item: any) => `(${item})`).join(', ') },
  ];



  return (
    <Box className={globalStyles.sectionContainer}>
      <Box className={globalStyles.sectionHeader}>
        <CustomText
          text="Patient Information"
          color={colors.primary}
          fontWeight={600}
        />
      </Box>

      <Divider />

      <Grid container p={3} spacing={1.5}>
        {fields.map((field, index) => (
          <React.Fragment key={field.label}>
            <Grid size={{ xs: 12, md: 6 }}>
              <CaseInfoItem
                label={field.label}
                value={field.value}
              />
            </Grid>

            {/* Insert divider after every 2 items, except the last pair */}
            {(index % 2 === 1 && index < fields.length - 1) && (
              <Grid size={12}>
                <Divider />
              </Grid>
            )}
          </React.Fragment>
        ))}
      </Grid>

    </Box>
  )
}
